// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"a9aaaa61","53":"6a8591e7","267":"668b3b29","397":"5d61ffce","407":"f4b1d673","552":"c1b4915a","586":"9e0fd90b","599":"981183f3"}[chunkId] + ".chunk.css";
};